"use strict";
'kiwi public';

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _create = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/create"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));

var _eventEmitter = _interopRequireDefault(require("event-emitter"));

var NetworkProvider = /*#__PURE__*/function () {
  function NetworkProvider() {
    (0, _classCallCheck2.default)(this, NetworkProvider);
    (0, _eventEmitter.default)(this);
    this.providers = [];
  }

  (0, _createClass2.default)(NetworkProvider, [{
    key: "addProvider",
    value: function addProvider(provider) {
      var _this = this;

      this.providers.push(provider);
      provider.on('networks', function (networks) {
        _this.emit('networks', _this.availableNetworks());
      });
    }
  }, {
    key: "availableNetworks",
    value: function availableNetworks() {
      var _context;

      var networks = (0, _create.default)(null);
      (0, _forEach.default)(_context = this.providers).call(_context, function (provider) {
        var pType = provider.type;

        if (provider.networks.length > 0) {
          var _context2;

          networks[pType] = networks[pType] || [];
          networks[pType] = (0, _concat.default)(_context2 = networks[pType]).call(_context2, provider.networks);
        }
      });
      return networks;
    }
  }]);
  return NetworkProvider;
}();

exports.default = NetworkProvider;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["NetworkProvider"]
window._kiwi_exports.libs.NetworkProvider = exports.default ? exports.default : exports;
